import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";

import solutions from "../../util/solutions-links";
import { useTranslate } from "../../hooks/useTranslate";

import * as S from "./styled";

import Logo from "../Logo";
import { SocialIcons } from "../SocialIcons";
import { ToggleLang } from "../ToggleLang";

const {
  digital_fraud,
  digital_brand,
  data_leakage,
  sales_abuse,
  executive_threats,
  threat_intelligence,
  content_removal,
  digital_risk_analysis,
} = solutions;

export function Footer({ isCleanFooter }) {
  const intl = useIntl();
  const { t } = useTranslate("solutions");

  return (
    <S.FooterWrapper isCleanFooter={isCleanFooter}>
      <S.Container>
        <Logo nameLogo="white-logo" to="/" />

        {!isCleanFooter && (
          <S.Row>
            <S.UseCases>
              <S.ColUseCases>
                <S.UseCasesList>
                  <h4>{t("reaction.content_removal.title")}</h4>
                  <ul>
                    {content_removal.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {t(`reaction.content_removal.solution_${index + 1}`)}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>
                <S.UseCasesList>
                  <h4>{t("monitoring.digital_brand.title")}</h4>
                  <ul>
                    {digital_brand.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {t(`monitoring.digital_brand.solution_${index + 1}`)}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>

                <S.UseCasesList>
                  <h4>{t("monitoring.executive_threats.title")}</h4>
                  <ul>
                    {executive_threats.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {t(
                            `monitoring.executive_threats.solution_${index + 1}`
                          )}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>
              </S.ColUseCases>

              <S.ColUseCases>
                <S.UseCasesList>
                  <h4>{t("monitoring.digital_fraud.title")}</h4>
                  <ul>
                    {digital_fraud.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {t(`monitoring.digital_fraud.solution_${index + 1}`)}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>

                <S.UseCasesList>
                  <h4>{t("monitoring.data_leakage.title")}</h4>
                  <ul>
                    {data_leakage
                      .filter(
                        ({ showOnlyForLangs }) =>
                          (showOnlyForLangs &&
                            showOnlyForLangs.includes(intl.locale)) ||
                          !showOnlyForLangs
                      )
                      .map(({ slug }, index) => (
                        <S.UseCaseItem key={index}>
                          {slug === "/hashcast/" ? (
                            <S.ExternalLink
                              as={"a"}
                              href="https://hashcast.axur.com/"
                              target="_blank"
                              rel="noreferrer"
                            >
                              {t(
                                `monitoring.data_leakage.solution_${index + 1}`
                              )}
                            </S.ExternalLink>
                          ) : (
                            <S.InternalLink
                              to={slug}
                              activeStyle={{ color: "var(--orange)" }}
                            >
                              {t(
                                `monitoring.data_leakage.solution_${index + 1}`
                              )}
                              {slug ===
                                "/monitoramento-vazamentos-dados-lgpd/" && (
                                <span>{t("new")}</span>
                              )}
                            </S.InternalLink>
                          )}
                        </S.UseCaseItem>
                      ))}
                  </ul>
                </S.UseCasesList>
              </S.ColUseCases>

              <S.ColUseCases>
                <S.UseCasesList>
                  <h4>{t("services.digital_risk_analysis.title")}</h4>
                  <ul>
                    {digital_risk_analysis.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {intl.formatMessage({
                            id: `solutions.services.digital_risk_analysis.solution_${
                              index + 1
                            }`,
                          })}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>
                <S.UseCasesList>
                  <h4>{t("monitoring.sales_abuse.title")}</h4>
                  <ul>
                    {sales_abuse.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {intl.formatMessage({
                            id: `solutions.monitoring.sales_abuse.solution_${
                              index + 1
                            }`,
                          })}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>

                <S.UseCasesList>
                  <h4>{t("monitoring.threat_intelligence.title")}</h4>
                  <ul>
                    {threat_intelligence.map(({ slug }, index) => (
                      <S.UseCaseItem key={index}>
                        <S.InternalLink
                          activeStyle={{ color: "var(--orange)" }}
                          to={slug}
                        >
                          {intl.formatMessage({
                            id: `solutions.monitoring.threat_intelligence.solution_${
                              index + 1
                            }`,
                          })}
                        </S.InternalLink>
                      </S.UseCaseItem>
                    ))}
                  </ul>
                </S.UseCasesList>
              </S.ColUseCases>
            </S.UseCases>

            {/* COL 04 - SOBRE NÓS */}
            <S.Menu>
              <h4>{intl.formatMessage({ id: "footer.about_us" })}</h4>
              <ul>
                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/por-que-axur/"
                  >
                    {intl.formatMessage({ id: "navbar.why_axur" })}
                  </S.InternalLink>
                </li>

                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/parceiros/"
                  >
                    {intl.formatMessage({ id: "navbar.partners" })}
                  </S.InternalLink>
                </li>

                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/press/"
                  >
                    {intl.formatMessage({ id: "press.title" })}
                  </S.InternalLink>
                </li>

                <li>
                  <S.ExternalLink
                    as={"a"}
                    href="https://blog.axur.com/"
                    target="_blank"
                    rel="noreferrer"
                    // title="Ir para o blog [Link externo]"
                  >
                    Blog
                  </S.ExternalLink>
                </li>

                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/talentos/"
                  >
                    {intl.formatMessage({ id: "footer.talent" })}
                  </S.InternalLink>
                </li>

                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/contato/"
                  >
                    {intl.formatMessage({ id: "footer.contact" })}
                  </S.InternalLink>
                </li>

                <li>
                  <S.InternalLink
                    activeStyle={{ color: "var(--orange)" }}
                    to="/politica-de-privacidade/"
                  >
                    {intl.formatMessage({ id: "footer.privacy_policy" })}
                  </S.InternalLink>
                </li>
              </ul>
            </S.Menu>
          </S.Row>
        )}

        <S.CopyRow>
          <S.Copy>
            © {new Date().getFullYear()}{" "}
            {intl.formatMessage({ id: "footer.copy" })}
          </S.Copy>

          <SocialIcons />
          <ToggleLang />
        </S.CopyRow>
      </S.Container>
    </S.FooterWrapper>
  );
}
